function IsInputSecure(value, isEmail = false) {
    var isValid = true;

    var disallowedCharacters = /[\[\]<>"%;^)(+-]/;
    if (isEmail) {
        disallowedCharacters = /[<>"'&%;)(]/; //allow "+", "-" characters in email address validation
    }

    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function IsInputNameValid(value) {
    var disallowedCharacters = /[\[\]<>"%;^)(+]/;
    return !disallowedCharacters.test(value);
}

function ValidateEmailRegex(value) {
    var isValid = true;
    if (!value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        isValid = false;
    }
    return isValid;
}

function ValidatePhoneRegex(value) {
    var isValid = true;
    //phone is valid if pass any of the test below:
    if (IsMobileValid(value)) {
        return isValid;
    }
    if (IsAustralianBusinessPhone(value)) {
        return isValid;
    }
    if (value.match(/^(?:\+?61[ \-.]?|0)[2378](?:[ \-.]?[0-9]){8}$/))
    {
        if (value.includes("-") && value.includes(".")) {
            return false;
        }
        return isValid;
    }
}

function IsPhoneValid(value) {
    //Plus, Hyphen, Dot, Space, and International Number will be allowed. Other special characters and alphabetical are not allowed."
    var isValid = true;

    if (!/^[0-9\-+. ]*$/.test(value)) {
        isValid = false;
    }
    return isValid;
}

function IsAustralianBusinessPhone(value) {
    var isValid = true;
    var regxphone1 = /^(1300)([0-9]{6})$/;
    var regxphone2 = /^(1800)([0-9]{6})$/;
    //remove spaces before testing with regex
    value = value.replace(/\s/g, ''); 
    if (!regxphone1.test(value) && !regxphone2.test(value)) {
        isValid = false;
    }
    return isValid;
}

function IsMobileValid(value) {
    var isValid = true;
    let regmm1 = /^04[0-9]{8}$/;
    let regmm2 = /^05[0-9]{8}$/;
    value = value.replace(/\s/g, '');
    if (!regmm1.test(value) && !regmm2.test(value)) {
        isValid = false;
    }
    return isValid;
}

function IsInputSecure_MiddysBranchSearch(value) {
    var isValid = true;

    var disallowedCharacters = /[\[\]<>^%]/;
    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function IsInputSecureDate(value) {
    var isValid = true;
    var disallowedCharacters = /[<>"'&^%;)(+]/;

    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function IsEVDropdownSecure(value) {
    var isValid = true;
    var disallowedCharacters = /[<>"%;+]/;

    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function IsFileUploadSecure(value) {
    var isValid = true;
    var disallowedCharacters = /[<>"%+]/;

    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function IsTextareaSecure(value) {
    var isValid = true;
    var disallowedCharacters = /[\[\]<>]/;

    if (disallowedCharacters.test(value)) {
        isValid = false;
    }

    return isValid;
}

function FullAddressSpecialCase(fullAddress, htmlElem) {
    //special case: Unit 1004, 92-100 Quay Street, Brisbane QLD 4000 which only returns Unit 1004, 100 Quay Street, Brisbane QLD 4000 so we need special treatment
    if (fullAddress.startsWith("Unit") && fullAddress.match(/,/g).length >= 2 && fullAddress.indexOf('-') > -1) {
        var data = fullAddress.split(",");
        $(htmlElem).val(data[0] + "," + data[1]);
    }
}

function WordCount(str) {
    return str.split(/[\s\n]+/)
        .filter(function (n) { return n != '' })
        .length;
}

function ValidatePostcode_Common(htmlElem) {
    var isValid = true;
    var postcode = $(htmlElem).val();
    if (!postcode.match(/^[0-9]{4}$/)) {
        isValid = false;
    }
    return isValid;
}

$('.keep-updated-block form .btn').click(function(){
    $(document).ajaxComplete(function(){
        var st = $('.keep-updated-block .container').offset().top;
        if ($(window).width() < 768) {
            $('html').animate({
                scrollTop: st - 100
            })
        }
        else {
            $('html').animate({
                scrollTop: st - 160
            })
        }
    })
})

function ValidateCheckboxPermissions(chkClassName) {
    var allCheckboxes = $(chkClassName);
    var totalChecked = 0;

    allCheckboxes.each(function ()
    {
        if ($(this).is(":checked"))
        { 
            totalChecked += 1;
        }
    });

    if (totalChecked < 1) {
        return false;
    }
    return true;
}